import React from "react";

import { Col, Option, Row, Select } from "components";

export const FieldSizeSelect = ({ fields, updateField }) => (
  <>
    <Row>
      <Col sm={24} md={8}>
        <Select
          name="field"
          label="Select field"
          rules={[{ required: true }]}
          style={{ width: "100%" }}
          showSearch
          filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          onChange={(v) => updateField(v)}
          optionLabelProp={"label"}
        >
          {fields.map((field, i) => {
            if (field.location) {
              return (
                <Option value={i} key={i} label={field.name}>
                  {field.name}
                  <br />
                  <small>{field.farmName}</small>
                </Option>
              );
            }
            return null;
          })}
        </Select>
      </Col>
    </Row>
  </>
);
